import { render, staticRenderFns } from "./discountCode.vue?vue&type=template&id=56b2295b&scoped=true"
import script from "./discountCode.vue?vue&type=script&lang=js"
export * from "./discountCode.vue?vue&type=script&lang=js"
import style0 from "./discountCode.vue?vue&type=style&index=0&id=56b2295b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2295b",
  null
  
)

export default component.exports